import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import ServiceDeskAppBase from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/app-base/index.tsx';
import { AppDiscoverySettings } from './ui';

export const AppDiscoveryPage = () => (
	<ServiceDeskAppBase appName={APP_NAMES.APP_DISCOVERY}>
		<Box xcss={appDiscoverySettingsContainerStyles}>
			<AppDiscoverySettings />
		</Box>
	</ServiceDeskAppBase>
);

export default AppDiscoveryPage;

const appDiscoverySettingsContainerStyles = xcss({
	marginTop: 'space.300',
});
